import { HomeActionCardViewModel } from '../types';

import { ActionCard } from './ActionCard';

type ActionCardGridProps = {
  cards: HomeActionCardViewModel[];
};

export function ActionCardGrid({ cards }: ActionCardGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
      {cards.map(card => (
        <ActionCard
          key={card.id}
          title={card.title}
          description={card.description}
          actionLabel={card.actionLabel}
          badge={card.badge}
          onAction={card.onAction}
          descriptionTitle={card.descriptionTitle}
        />
      ))}
    </div>
  );
}
